import { clsx } from 'clsx';

export function EnergyBar({ current, max }: { current: number; max: number }) {
  const pct = Math.max(0, Math.min(100, (current / max) * 100));
  const color = pct < 20 ? 'bg-destructive' : pct < 50 ? 'bg-primary' : 'bg-accent';

  return (
    <div className="w-full bg-input h-3 rounded-sm overflow-hidden border border-border relative shadow-inner">
      <div
        className={clsx('h-full transition-all duration-500 ease-out relative', color)}
        style={{ width: `${pct}%` }}
      >
        <div className="absolute inset-0 bg-[linear-gradient(90deg,transparent_0%,rgba(255,255,255,0.1)_50%,transparent_100%)] animate-pulse" />
      </div>
    </div>
  );
}

export function RadiationBar({ current }: { current: number }) {
  const pct = Math.max(0, Math.min(100, current * 100));
  return (
    <div className="w-full bg-input h-3 rounded-sm overflow-hidden border border-border relative shadow-inner">
      <div
        className="h-full transition-all duration-300 bg-accent shadow-[0_0_10px_rgba(101,163,13,0.5)] relative"
        style={{ width: `${pct}%` }}
      >
        <div className="absolute inset-0 bg-[repeating-linear-gradient(90deg,transparent,transparent_2px,rgba(0,0,0,0.2)_2px,rgba(0,0,0,0.2)_4px)]" />
      </div>
    </div>
  );
}
